import { call, put, select, delay } from 'redux-saga/effects';
import SUBSCRIPTION_ACTION from '../actionTypes/Subscriptions';
import SubscriptionsApi from '../apis/SubscriptionsApi';

export const vehicleCapable = ({ vehicleCapable }) => vehicleCapable.vehicle_capable;

/**
 * @name get subscription
 * @description get subscription status
 * @note  will use commented code for future sprint work to check the vehicle capability
*/

export function* getSubscription() {
  try {
    // fetch value from VehicleCapable
    // const remoteCapable = yield select(vehicleCapable);
    // if (remoteCapable) {
    //   yield delay(3000);
    const response = yield call(SubscriptionsApi.get);
    const payload = response || {};
    let flag = false;
    /* Just checking remote user guid with subscription guid,
     in future sprint will handle the case of primary user and secondary user
     */
    const isPrimaryUser = payload.payload.subscription.remoteUser.remoteUserGuid === payload.payload.subscription.userProfileGuid;
    const isIncorrectUser = payload.payload.subscription.remoteUser.remoteUserGuid !== payload.payload.subscription.userProfileGuid;
    const isSecondaryUser = payload.payload.subscription.remoteUser.remoteUserGuid !== payload.payload.subscription.subscriberGuid;

    if (isPrimaryUser || isIncorrectUser || isSecondaryUser) {
      const responseData = yield call(SubscriptionsApi.getStatus, payload.payload.subscription.remoteUser.remoteUserGuid);
      if (responseData.payload.remoteUserStatus === 'True') {
        flag = true;
      }
    }
    yield put({
      type: SUBSCRIPTION_ACTION.SUBSCRIPTION_SUCCESS,
      payload: flag,
    });
    // }
  } catch (error) {
    yield put({
      type: SUBSCRIPTION_ACTION.SUBSCRIPTION_ERROR,
      error,
    });
  }
}
